import { Box, Link as ChakraLink, Flex, Image, Text } from '@chakra-ui/react'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import { FaLinkedin, FaSquareXTwitter } from 'react-icons/fa6'
import mosaicaLogo from 'images/logo-mosaica.png'

export default function Footer() {
  const { menusState } = useSelector((state: any) => state.common)
  const currentYear = new Date().getFullYear()

  const getMenuItems = () => {
    if (menusState.header.isFetching) {
      return null
    }
    if (menusState.header.isFetched && menusState.header.items.length) {
      return menusState.header.items.map((item: any) => {
        // if (!item.visible) {
        //   return null
        // }
        return (
          <ChakraLink
            asChild
            key={item.url}
            fontSize='sm'
            color='#B5B5B5'
            textDecoration='none'
            p='8px 0'
            display='block'
            textAlign={{ base: 'center', sm: 'left' }}
            _hover={{ opacity: '0.8' }}
          >
            <Link to={item.url}>{item.label}</Link>
          </ChakraLink>
        )
      })
    }
  }
  return (
    <Box as='footer' bgColor='#2F2F2F' p='60px 0px 0px'>
      <Box maxW='1140px' m='auto' p='0px 20px'>
        <Box>
          <Link to='/'>
            <Flex justifyContent={{ base: 'center', md: 'flex-start' }}>
              <svg width='168px' viewBox='0 0 349 62' fill='none'>
                <path
                  d='M0 30.6433V30.8041C0.194053 38.8783 3.53784 46.5565 9.31703 52.1985C15.0962 57.8405 22.8526 60.9988 30.9291 60.9988C39.0057 60.9988 46.7621 57.8405 52.5412 52.1985C58.3204 46.5565 61.6642 38.8783 61.8583 30.8041V30.6433H0Z'
                  fill='#008CFF'
                />
                <path
                  d='M62.8944 61.8672H63.0552C67.1794 61.9663 71.2818 61.2396 75.121 59.7298C78.9602 58.22 82.4587 55.9577 85.4106 53.0758C88.3626 50.194 90.7083 46.7509 92.3099 42.949C93.9115 39.1472 94.7366 35.0635 94.7366 30.9381C94.7366 26.8127 93.9115 22.7289 92.3099 18.9271C90.7083 15.1253 88.3626 11.6821 85.4106 8.8003C82.4587 5.91845 78.9602 3.65608 75.121 2.1463C71.2818 0.636511 67.1794 -0.090188 63.0552 0.00893202H62.8944V61.8672Z'
                  fill='#008CFF'
                />
                <g>
                  <path
                    d='M127.825 26.9993H127.718L121.252 47.8986H115.768L105.89 18.068H112.463L118.393 38.9851H118.501L125.539 18.068H130.04L137.06 38.9851H137.185L143.08 18.068H149.671L139.811 47.8986H134.291L127.825 26.9993Z'
                    fill={'#008CFF'}
                  />
                  <path
                    d='M153.815 32.9476C153.731 30.5041 154.001 28.0612 154.619 25.6954C155.135 24.1241 156.016 22.6976 157.191 21.5334C158.192 20.4167 159.407 19.5117 160.764 18.8719C162.587 18.0535 164.57 17.6508 166.569 17.693C168.608 17.6447 170.633 18.0473 172.499 18.8719C173.817 19.5237 174.99 20.435 175.947 21.5513C177.179 22.6784 178.086 24.1158 178.573 25.7133C179.133 28.0821 179.38 30.5145 179.305 32.9476C179.378 35.3512 179.131 37.7538 178.573 40.0927C178.07 41.7139 177.167 43.1822 175.947 44.3618C175.504 44.8449 175.013 45.2817 174.482 45.6658C173.898 46.1895 173.227 46.6067 172.499 46.8983C170.654 47.7946 168.62 48.2356 166.569 48.1844C164.559 48.2288 162.567 47.7876 160.764 46.8983C159.423 46.2872 158.21 45.4264 157.191 44.3618C156.029 43.146 155.151 41.6881 154.619 40.0927C154.004 37.763 153.733 35.3558 153.815 32.9476ZM173.107 32.9476C173.146 31.3817 173.044 29.8154 172.803 28.2676C172.616 27.3501 172.198 26.4955 171.588 25.7847C171.069 25.0776 170.364 24.5274 169.552 24.195C168.611 23.7867 167.594 23.5857 166.569 23.6055C165.56 23.5922 164.56 23.7995 163.639 24.2128C162.826 24.5606 162.109 25.0999 161.55 25.7847C160.997 26.5245 160.602 27.3695 160.388 28.2676C160.107 29.7868 159.987 31.3317 160.031 32.8762C159.984 34.403 160.104 35.9303 160.388 37.4312C160.52 38.3438 160.89 39.2056 161.461 39.93C162.032 40.6543 162.783 41.2156 163.639 41.5574C164.555 41.9904 165.556 42.2103 166.569 42.2005C167.6 42.2218 168.621 42.0015 169.552 41.5574C170.334 41.2068 171.029 40.6884 171.588 40.0391C172.2 39.2823 172.618 38.3868 172.803 37.4312C173.009 35.9701 173.08 34.4932 173.017 33.0191L173.107 32.9476Z'
                    fill={'#008CFF'}
                  />
                  <path
                    d='M186.754 18.068H192.97V21.2297H193.113C194.099 20.0692 195.333 19.1455 196.725 18.527C198.116 17.9086 199.629 17.6113 201.151 17.6572C203.517 17.6492 205.813 18.4566 207.653 19.9436L203.116 25.1238C201.96 24.1919 200.528 23.6704 199.043 23.6412C197.543 23.6098 196.085 24.1384 194.953 25.1238C194.28 25.7099 193.753 26.4441 193.412 27.2685C193.071 28.093 192.926 28.9852 192.988 29.8752V47.8629H186.772L186.754 18.068Z'
                    fill={'#008CFF'}
                  />
                  <path
                    d='M211.261 5.99292H217.478V40.2356C217.478 41.5931 218.246 42.2719 219.8 42.2719H221.961V47.8986H219.192C217.201 47.9843 215.236 47.4132 213.601 46.2731C212.779 45.6074 212.135 44.7482 211.727 43.7725C211.319 42.7967 211.159 41.7349 211.261 40.6821V5.99292Z'
                    fill={'#008CFF'}
                  />
                  <path
                    d='M264.867 35.2519C264.799 36.2647 264.955 37.2801 265.326 38.2251C265.697 39.1701 266.272 40.0214 267.01 40.7178C268.442 42.0176 270.33 42.6982 272.262 42.6113C273.524 42.6051 274.772 42.3459 275.931 41.8488C277.091 41.3518 278.139 40.627 279.014 39.7175L283.516 43.4151C282.109 44.9625 280.389 46.1929 278.47 47.0245C276.552 47.856 274.478 48.2697 272.387 48.238C270.773 48.2454 269.166 48.0168 267.618 47.5592C266.833 47.3017 266.079 46.9604 265.367 46.541C264.589 46.1849 263.857 45.735 263.188 45.2014C261.758 43.9311 260.66 42.3306 259.99 40.5392C259.017 38.1746 258.566 35.6276 258.669 33.0726C258.588 30.5683 258.982 28.0713 259.83 25.7132C260.451 23.9383 261.464 22.3264 262.795 20.9975C263.975 19.8603 265.389 18.9946 266.939 18.461C268.377 17.9667 269.885 17.7074 271.405 17.6929C274.697 17.6543 277.884 18.8527 280.336 21.0511C281.592 22.2357 282.579 23.6767 283.229 25.2763C283.88 26.8759 284.178 28.5966 284.105 30.3218V35.2519H264.867ZM277.942 30.3218C278.026 28.3486 277.326 26.4224 275.995 24.963C274.722 23.8571 273.091 23.2482 271.405 23.2482C269.718 23.2482 268.088 23.8571 266.814 24.963C265.512 26.4399 264.817 28.3539 264.867 30.3218H277.942Z'
                    fill={'#008CFF'}
                  />
                  <path
                    d='M292.59 38.7887C293.871 40.0648 295.401 41.0628 297.085 41.7206C298.77 42.3783 300.572 42.6815 302.378 42.6113C303.906 42.6739 305.423 42.3287 306.773 41.611C307.308 41.3594 307.761 40.9601 308.077 40.4602C308.393 39.9602 308.561 39.3804 308.559 38.7887C308.608 38.361 308.542 37.9278 308.366 37.5348C308.19 37.1418 307.911 36.8037 307.559 36.5559C306.709 36.0733 305.749 35.8208 304.772 35.8235L299.288 35.3769C296.946 35.2573 294.71 34.3654 292.929 32.8404C292.082 32.1051 291.411 31.1887 290.966 30.1591C290.521 29.1295 290.312 28.013 290.357 26.8922C290.292 25.5513 290.567 24.2158 291.157 23.0101C291.748 21.8044 292.634 20.7679 293.733 19.9972C296.141 18.3827 298.999 17.5757 301.896 17.693C303.181 17.6824 304.465 17.7719 305.737 17.9609C306.825 18.1273 307.896 18.3965 308.934 18.7647C310.795 19.4798 312.526 20.4934 314.061 21.7656L310.113 26.142C308.933 25.3154 307.662 24.6262 306.326 24.0878C304.869 23.5773 303.333 23.3294 301.789 23.3554C300.349 23.2155 298.905 23.575 297.698 24.3736C297.31 24.6822 296.998 25.0767 296.787 25.5261C296.576 25.9754 296.473 26.4675 296.484 26.9637C296.465 27.3172 296.541 27.6693 296.705 27.9834C296.868 28.2976 297.112 28.5622 297.413 28.7499C298.331 29.425 299.435 29.7993 300.574 29.8217L305.701 30.1789C306.993 30.1667 308.276 30.4097 309.474 30.8941C310.673 31.3784 311.764 32.0944 312.685 33.0012C314.062 34.7393 314.772 36.9125 314.686 39.1281C314.702 40.4623 314.372 41.778 313.727 42.946C313.082 44.114 312.144 45.0944 311.006 45.7908C308.268 47.4972 305.085 48.355 301.86 48.2559C296.803 48.2564 291.934 46.3417 288.231 42.8971L292.59 38.7887Z'
                    fill={'#008CFF'}
                  />
                  <path
                    d='M321.92 5.99292H328.119V32.0545H328.262L340.14 18.068H347.589L336.871 29.7145L349 47.8986H341.194L332.959 33.9658L328.065 39.3246V47.9165H321.867L321.92 5.99292Z'
                    fill={'#008CFF'}
                  />
                  <path
                    d='M253.649 5.86792H247.558V18.9969C247.362 18.8898 247.201 18.7469 246.987 18.6397C245.121 17.8134 243.096 17.4108 241.056 17.4608C239.058 17.421 237.075 17.8236 235.251 18.6397C233.899 19.2799 232.686 20.1779 231.678 21.2834C230.513 22.4583 229.638 23.8898 229.124 25.4632C228.507 27.829 228.236 30.2719 228.32 32.7154C228.238 35.1236 228.509 37.5308 229.124 39.8605C229.642 41.4581 230.516 42.9176 231.678 44.1297C232.697 45.1942 233.91 46.055 235.251 46.6662C237.054 47.5554 239.046 47.9966 241.056 47.9523C243.108 48.0055 245.142 47.5644 246.987 46.6662C247.185 46.5795 247.376 46.478 247.558 46.3625V47.5771H253.649C253.685 44.469 253.649 5.86792 253.649 5.86792ZM247.29 37.1811C247.105 38.1367 246.688 39.0322 246.076 39.789C245.512 40.4334 244.818 40.9509 244.039 41.3074C243.109 41.7534 242.087 41.9737 241.056 41.9504C240.044 41.9603 239.042 41.7404 238.127 41.3074C237.35 40.9226 236.643 40.4092 236.037 39.789C235.484 39.0036 235.089 38.1177 234.876 37.1811C234.592 35.6803 234.472 34.1529 234.519 32.6261C234.474 31.0816 234.594 29.5368 234.876 28.0176C235.09 27.1194 235.485 26.2745 236.037 25.5347C236.596 24.8443 237.312 24.299 238.127 23.9449C239.05 23.538 240.048 23.331 241.056 23.3376C242.083 23.3234 243.1 23.5305 244.039 23.9449C244.855 24.2707 245.562 24.8221 246.076 25.5347C246.685 26.2455 247.103 27.1001 247.29 28.0176C247.46 28.985 247.55 29.9648 247.558 30.947V34.3588C247.549 35.3055 247.459 36.2496 247.29 37.1811Z'
                    fill={'white'}
                  />
                </g>
              </svg>
            </Flex>
          </Link>
          <Flex
            mt='60px'
            justifyContent='space-between'
            flexDirection={{ base: 'column', md: 'row' }}
            rowGap='50px'
          >
            <Box>{getMenuItems()}</Box>
            <Flex columnGap='30px' justifyContent='center'>
              <Box>
                <Box color='white' fontWeight='500' mb='12px'>
                  Contact Information
                </Box>
                <Text color='#B5B5B5' fontSize='sm' my='20px'>
                  2980 NE 207 Street,
                  <br />
                  Miami, FL 33180
                </Text>
                <Text color='#B5B5B5' fontSize='sm'>
                  1072 Madison Avenue Lakewood,
                  <br />
                  New Jersey, 08701
                </Text>
              </Box>
              <Box>
                <Box color='white' fontWeight='500' mb='12px'>
                  Follow Us
                </Box>
                <Flex columnGap='16px'>
                  <ChakraLink
                    href='https://www.linkedin.com/company/2625693'
                    target='_blank'
                  >
                    <FaLinkedin color='white' size='30' />
                  </ChakraLink>
                  <ChakraLink href='https://x.com/MosaicaFX' target='_blank'>
                    <FaSquareXTwitter color='white' size='30' />
                  </ChakraLink>
                </Flex>
                <Box w='190px' h='1px' my='20px' bgColor='#949494' />
                <Box color='white' fontWeight='500' mb='12px'>
                  Powered By
                </Box>
                <ChakraLink href='https://mosaicafx.com' target='_blank'>
                  <Image src={mosaicaLogo} w='90px' />
                </ChakraLink>
              </Box>
            </Flex>
          </Flex>
        </Box>
      </Box>
      <Box
        color='#B5B5B5'
        textAlign='center'
        fontSize='sm'
        bgColor='#383838'
        p='20px 20px'
        mt='80px'
      >
        <Text>
          © 2018 – {currentYear}. Worldesk, a subsidiary of Mosaica, Inc. All
          rights reserved.
        </Text>
        <Text>
          © Mosaica, Inc.&nbsp; |&nbsp;{' '}
          <ChakraLink asChild color='inherit'>
            <Link to='/legal'>Legal Disclaimer</Link>
          </ChakraLink>
          &nbsp; |&nbsp;{' '}
          <ChakraLink asChild color='inherit'>
            <Link to='/privacy-policy'>Privacy Policy</Link>
          </ChakraLink>
          &nbsp; |&nbsp;{' '}
          <ChakraLink asChild color='inherit'>
            <Link to='/terms-of-service'>Terms of Service</Link>
          </ChakraLink>
        </Text>
      </Box>
    </Box>
  )
}
